import * as React from 'react';

enum OrderingDirection {
  ASC = 'asc',
  DESC = 'desc',
  UNORDERED = 'unsorted',
}

export const useOrdering = () => {
  const [orderedBy, setOrderedBy] = React.useState<string>();
  const [orderDirection, setOrderDirection] = React.useState(OrderingDirection.UNORDERED);

  function setOrderDirectionHelper(key: string) {
    let newOrderDirection = OrderingDirection.ASC;

    if (key === orderedBy) {
      if (orderDirection === OrderingDirection.ASC) {
        newOrderDirection = OrderingDirection.DESC;
      } else if (orderDirection === OrderingDirection.DESC) {
        newOrderDirection = OrderingDirection.UNORDERED;
      }
    } else {
      setOrderedBy(key);
    }

    setOrderDirection(newOrderDirection);
  }

  function orderDirectionHelper(key: string) {
    if (key === orderedBy) {
      return orderDirection;
    }
    return OrderingDirection.UNORDERED;
  }

  function getOrderParamForAPIV3() {
    if (orderDirection === OrderingDirection.ASC) {
      return orderedBy;
    }
    if (orderDirection === OrderingDirection.DESC) {
      return `-${orderedBy}`;
    }
    return undefined;
  }

  return {
    orderedBy,
    orderDirection,
    getOrderDirection: orderDirectionHelper,
    setOrderDirection: setOrderDirectionHelper,
    getOrderParamForAPIV3,
  };
};
